import CategorySelect from './components/categorySelect';
import "./components/more";

(function () {

    const sampleResults = `
    <a href="#" class="articlePreview articlePreview--blog">
<div class="articlePreview__imageWrapper">
<img class="articlePreview__image" src="/wp-content/themes/nswm/assets/test/article-thumbnail.jpg" alt="">
</div>
<div class="articlePreview__volunteers">
<span onclick="swmGoTo(event, #)">Monika Cieżak, Szymon Cieżak</span>
</div>
<h3 class="articlePreview__title">blog.js - Wśród indian Yanomami – powrót do lat dzieciństwa</h3>
<div class="articlePreview__countries">
Brazylia, Manaus 2019-2020
</div>
<div class="articlePreview__date">
22 kwietnia 2020
</div>
</a>`;



    const resultsContainer = document.getElementById("categoryResults");
    const placeholder = document.getElementById("categoryPlaceholder");

    const categoriesBar = document.getElementById(
      'blogCategoriesSelect'
    );


    const handleCategorySelectFn = function (categoryName, pageNumber) {
           console.log(categoryName, pageNumber);
      const resultsFragment = document.createElement('template');
      resultsFragment.innerHTML = sampleResults;
      resultsContainer.appendChild(resultsFragment.content);
      return true;
    };

    const categorySelect = new CategorySelect({
      resultsContainer: resultsContainer,
      categoriesBar: categoriesBar,
      placeholder: placeholder,
      handleCategorySelectFn: handleCategorySelectFn,
    });


})();